const module = { name: 'fd-header/globalSearch', exports: {} }; const exports = module.exports;



import { default as $ } from 'swug-fdRequire-call:jQuery';



import { default as searchAutocomplete } from 'swug-fdRequire-call:fd-header/searchAutocomplete';



import { swig as swig } from 'require-core';



const Selectors = {
    ANCHOR: 'a',
    AUTOCOMPLETE: '.js-fd-header-nav-bar-search-autocomplete',
    CATEGORY: '.js-fan-autocomplete-category',
    FORM: 'form',
    SEARCH: '#global-search',
}


let $autocomplete
function onAutocompleteRender(results) {
    return swig.render('_searchResults', results);
}
function onSubmit(e) {
    const links = $autocomplete.find(Selectors.CATEGORY).find(Selectors.ANCHOR);
    if (links.length === 1) {
        e.preventDefault();
        links[0].click();
    }
}
function init() {
    const $search = $(Selectors.SEARCH);
    const $searchForm = $search.find(Selectors.FORM);
    $autocomplete = $search.find(Selectors.AUTOCOMPLETE);
    searchAutocomplete.init($autocomplete, {
        render: onAutocompleteRender
    });
    $searchForm.on('submit', onSubmit);
}
module.exports = {
    init,
};
export default module.exports;